import { useGetScriptsInfo } from '@automata/wfb-api';
import { useEffect } from 'react';

import { loadScripts } from '../features/actions';
import { useAppDispatch } from '../hooks';

export const useInitializeScripts = () => {
  const dispatch = useAppDispatch();

  const {
    data: getScriptsInfoData, // "get scripts info" useEffect only
    error: getScriptsInfoError, // "get scripts info" useEffect only
    isLoading: getScriptsInfoIsLoading, // shows the Spinner
  } = useGetScriptsInfo({});

  useEffect(() => {
    if (!getScriptsInfoData) {
      return;
    }
    dispatch(loadScripts(getScriptsInfoData));
  }, [dispatch, getScriptsInfoData]);

  return { getScriptsInfoError, getScriptsInfoIsLoading };
};
